import { API } from "src/domains/shared/utils/amplifyCompat";
import { DRONESQUARE_API_GATEWAY } from "src/domains/shared/constants/constants";

export type RenameLayerParams = {
  /** 백엔드 layer-data 카테고리 enum — UI 의 "line" 은 호출 전에 "linear" 로 매핑한다. */
  type: "gis" | "linear" | "bim" | "las";
  /** 확장자를 제외한 s3 파일명 stem (NFD 정규화는 백엔드 담당) */
  origin_file_name: string;
  display_name: string;
};

/**
 * 레이어 표시명(display_name) 변경 — 프로젝트 전역 (time_project 무관).
 * 2D 검사 페이지·프로젝트 페이지가 공유하는 단일 호출 지점.
 */
export async function renameLayerDisplayName(
  projectId: number,
  params: RenameLayerParams
): Promise<unknown> {
  const res = await API.post(
    DRONESQUARE_API_GATEWAY,
    `projects/${projectId}/layer-data`,
    { body: params }
  );
  // 응답 봉투 { status, data } 언랩
  return (res as any).data ?? res;
}
